module.exports = "/virtual-football-league/img/amblems/left/logos/Bordeaux.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/left/logos/Bordeaux.png
// module id = 2057
// module chunks = 4